import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import { AmaruViewGenericClass } from 'amaru-web-components';
import { AuthService } from 'base-angular-avla';
import moment from 'moment/moment';
import {
  AvlaGenericComponent,
  InfoMessageDTO,
  MessageService,
} from 'shared-angular-components-avla';

import { States } from 'app/core/enums';
import { DynamicInputForm, OptionCombobox } from 'app/core/interfaces';

import { SinisterService } from '../../../service/sinister.service';
import { StatusRegisterDTO } from '../../interface/newStatusRegister';
import { FormatToService } from '../../service/Validators/format-to.service';
import { ConsultaMarkListService } from '../../service/consulta-mark-list.service';

@Component({
  selector: 'app-ml-create-status-person',
  templateUrl: './ml-create-status-person.component.html',
  styleUrls: ['./ml-create-status-person.component.css'],
})
export class MlCreateStatusPersonComponent
  extends AmaruViewGenericClass
  implements OnInit
{
  @Input() statusData: any[];
  @Input() showSubmit = true;
  @Output() refresh = new EventEmitter();

  reactiveForm: FormGroup;
  loadingImg = false;
  currentUser = '';
  dinamicFormInputsData: DynamicInputForm[];
  userSeguimiento: any;
  sistemasBloquear: any[] = [];
  idStatusList: any[] = [];
  idStatusListCopy: any[] = [];
  idStatusListEditMode: any[] = [];
  isLoadingSubarea: boolean;
  loadingImgAlertType: boolean;
  loadingImgRegisterType: boolean;
  subAreaLoaded = false;
  alertTypeLoaded = false;
  /*
    No se llaman todos al mismo tiempo, se van llamando a medida que los necesita el usuario
    y se almacenan. Esto requiere la mejora creando un endpoint que traiga toda la data
    de areas, subAreas y tipos de alertas y que el front las muestre segun lo requerido
    para no hacer consultas recurrentes por cada cambio de elemento seleccionado en el dropdown
  */
  allAreas: OptionCombobox[] = [];
  allSubareas: OptionCombobox[] = [];
  allAlertTypes: OptionCombobox[] = [];
  allRegisterTypes: OptionCombobox[] = [];

  currentSubareas: OptionCombobox[] = [];
  currentAlertTypes: OptionCombobox[] = [];
  currentRegisterType: OptionCombobox[] = [];
  
  registrationAreaOld: string | null = null;

  constructor(
    injector: Injector,
    protected formBuilder: FormBuilder,
    protected formatToService: FormatToService,
    protected marklistService: ConsultaMarkListService,
    protected messageService: MessageService,
    protected sinisterService: SinisterService,
    protected authService: AuthService
  ) {
    super(injector, {});
  }

  ngOnInit(): void {
    console.log('[MlCreateStatusPersonComponent] init');
    this.currentUser = localStorage.getItem('storedUsername');
    this.createForm();
    this.getDynamicFormInputs();
    this.reactiveForm.get('registrationArea').valueChanges.subscribe(value => {
      this.subAreaLoaded = false;
      this.alertTypeLoaded = false;
      this.getOptionSubArea();
    });

    this.reactiveForm.get('subArea').valueChanges.subscribe(value => {
      this.alertTypeLoaded = false;
      this.getOptionAlertType();
    });

    this.reactiveForm.get('alertType').valueChanges.subscribe(value => {
      if (value) {
        this.getOptionRegisterType();
      }
    });
  }

  createForm(): void {
    this.reactiveForm = this.formBuilder.group({
      registrationArea: ['', Validators.required],
      subArea: ['', Validators.required],
      alertType: ['', Validators.required],
      registerType: ['', Validators.required],
      motivo: ['', [Validators.maxLength(300)]],
      idStatus: ['', Validators.required],
      sistemaBloquear: ['', Validators.required],
      observation: ['', [Validators.maxLength(300)]],
    });
  }

  getDynamicFormInputs() {
    const date = moment(new Date()).add(1, 'days').format('YYYY-MM-DD');
    this.sinisterService
      .getDynamicFormInputsAtDate('ML_REGISTRO_ESTADO', date)
      .subscribe({
        next: res => {
          this.dinamicFormInputsData = res;
          const areaField = this.dinamicFormInputsData.find(
            field => field.inputName === 'registrationArea'
          );
          const sistemaBloquearField = this.dinamicFormInputsData.find(
            field => field.inputName === 'sistemaBloquear'
          );

          const allowedAreas = this.getAllowedAreas(
            areaField?.possibleValues || []
          );

          this.allAreas = allowedAreas;
          this.sistemasBloquear = sistemaBloquearField
            ? sistemaBloquearField.possibleValues
            : [];
          this.getOptionState();
        },
        error: err => {
          console.log('error', err);
        },
      });
  }

  buildDataToSave(): StatusRegisterDTO {
    const statusRegisterDTO: StatusRegisterDTO = {
      idPerson: this.statusData[0].idPerson,
      dniPerson: this.statusData[0].dniPerson,
      namePerson: this.statusData[0].namePerson,
      personType: this.statusData[0].personType,
      identificationType: this.statusData[0].identificationType,
      registrationArea: this.reactiveForm.get('registrationArea').value,
      subArea: this.reactiveForm.get('subArea').value,
      alertType: this.reactiveForm.get('alertType').value,
      registerType: this.reactiveForm.get('registerType').value,
      idStatus: parseInt(this.reactiveForm.get('idStatus').value),
      systemsBlocked: this.reactiveForm.get('sistemaBloquear').value,
      observation: this.reactiveForm.get('observation').value,
      countSinister: 0,
      registerDate:
        moment(new Date()).add(1, 'days').format('YYYY-MM-DD') + 'T00:00:00',
    };

    // Area
    statusRegisterDTO.registrationArea = this.allAreas.find(
      area => area.cdOption === statusRegisterDTO.registrationArea
    ).label;

    // Subrea
    statusRegisterDTO.subArea = this.allSubareas.find(
      subarea => subarea.cdOption === statusRegisterDTO.subArea
    ).label;

    // Tipo de alerta - motivo
    const motive = this.reactiveForm.get('motivo').value;

    statusRegisterDTO.alertType = motive
      ? `Otro: ${motive}`
      : this.allAlertTypes.find(
          alertType => alertType.cdOption === statusRegisterDTO.alertType
        ).label;

    // Tipo de registro
    statusRegisterDTO.registerType = this.allRegisterTypes.find(
      registerType => registerType.cdOption === statusRegisterDTO.registerType
    ).label;

    return statusRegisterDTO;
  }

  submitForm(): void {
    this.loadingImg = true;
    if (!this.reactiveForm.valid) return;
    const statusRegisterDTO: StatusRegisterDTO = this.buildDataToSave();

    this.marklistService
      .newStatusRegister(statusRegisterDTO, this.isAllowedToBlockDirectly())
      .subscribe({
        next: () => {
          this.messageService.announcedMessage(
            new InfoMessageDTO(
              'success',
              'Se ha ingresado registro',
              AvlaGenericComponent.TIME_NOTIFICATION
            )
          );
          this.loadingImg = false;
          this.clickReload();
          this.resetForm();
        },
        error: err => {
          this.messageService.announcedMessage(
            new InfoMessageDTO(
              'danger',
              'No se a podido ingresar el registro. Vuelva a intentarlo',
              AvlaGenericComponent.TIME_NOTIFICATION
            )
          );
          this.loadingImg = false;
          return;
        },
      });
  }

  clickReload() {
    this.refresh.emit();
  }

  resetForm(): void {
    this.reactiveForm.get('sistemaBloquear').reset();
    this.reactiveForm.get('registrationArea').reset();
    this.reactiveForm.get('idStatus').reset();
    this.reactiveForm.get('observation').reset();
    this.updateAreaDependingFields();
  }

  updateAreaDependingFields() {
    if (this.registrationAreaOld === this.reactiveForm.get('registrationArea').value) return;

    this.registrationAreaOld = this.reactiveForm.get('registrationArea').value;

    this.reactiveForm.get('subArea').reset();
    this.reactiveForm.get('alertType').reset();
    this.reactiveForm.get('motivo').reset();
    this.reactiveForm.get('registerType').reset();
    this.currentSubareas = [];
    this.currentAlertTypes = [];
    this.currentRegisterType = [];
  }

  // TODO: Verificar en reglas de negocio si es necesaria esta validacion
  getAllowedAreas(res: any[]) {
    return (res || []).filter((area: any) => {
      console.log('area metadata: ', JSON.parse(area.metadata));
      const metadata = JSON.parse(area.metadata);
      return (metadata.auth || []).some((auth: any) => {
        if (AuthService.optionsTree) {
          return this.authService.isAllowedHtmlElement(
            auth?.authElementCode ?? null,
            auth?.authElementName ?? null
          );
        }
        return false;
      });
    });
  }

  getOptionState() {
    this.marklistService.getStatusList(true).subscribe(
      data => {
        this.idStatusList = data;
        this.idStatusListCopy = data.filter(
          x => x.nameStatus !== States.DESBLOQUEADO
        );

        this.idStatusListEditMode = data.filter(
          x => x.nameStatus === States.DESBLOQUEADO
        );
      },
      error => console.log('error', error)
    );
  }

  getOptionSubArea() {
    if (this.subAreaLoaded || !this.reactiveForm.get('registrationArea').value) return;

    this.isLoadingSubarea = true;
    const areaCdOption = this.reactiveForm.get('registrationArea').value!;

    // Si no existen las subareas cargadas para la opcion, se consulta
    this.sinisterService.getOptionsCombobox(areaCdOption).subscribe({
      next: res => {
        const subareas = this.getAllowedAreas(res);
        this.currentSubareas = subareas;
        this.allSubareas.push(...subareas);
      },
      error: err => console.log(err),
      complete: () => {
        this.isLoadingSubarea = false;
        this.subAreaLoaded = true;
      },
    });
  }

  getOptionAlertType() {
    if (this.alertTypeLoaded || !this.reactiveForm.get('subArea').value) return;

    this.loadingImgAlertType = true;
    const subareaCdOption = this.reactiveForm.get('subArea').value;

    const cdSelect =
      this.formatToService.getCdSelectForAlertTypeFromSubarea(subareaCdOption);

    this.sinisterService.getOptionsCombobox(cdSelect).subscribe({
      next: res => {
        this.allAlertTypes.push(...res);
        this.currentAlertTypes = res;
      },
      error: err => console.log(err),
      complete: () => {
        this.loadingImgAlertType = false;
        this.alertTypeLoaded = true;
      },
    });
  }

  getOptionRegisterType(): void {
    this.loadingImgRegisterType = true;

    const option = this.reactiveForm.get('alertType').value!;
    const registerTypeCdOption =
      this.formatToService.formatToRegisterType(option);

    this.sinisterService.getOptionsCombobox(registerTypeCdOption).subscribe({
      next: res => {
        this.currentRegisterType = res;
        this.allRegisterTypes.push(...res);
        const registerType = res.length > 0 ? res[0].cdOption : null;
        this.reactiveForm.get('registerType')?.setValue(registerType);
      },
      error: err => console.log(err),
      complete: () => (this.loadingImgRegisterType = false),
    });
  }

  validateAllFormFields(formGroup: FormGroup) {
    //{1}
    Object.keys(formGroup.controls).forEach(field => {
      //{2}
      const control = formGroup.get(field); //{3}
      if (control instanceof FormControl) {
        //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        //{5}
        this.validateAllFormFields(control); //{6}
      }
    });
  }

  public getStatusData(): any {
    if (!this.reactiveForm.valid) {
      this.validateAllFormFields(this.reactiveForm);
      return null;
    }
    return this.buildDataToSave();
  }

  isAllowedToBlockDirectly(): boolean {
    return this.authService.isAllowedHtmlElement(19506, 'BTN_DIRECT_BLOCK');
  }

  onCheckboxChange(event: Event, value: string): void {
    const checkbox = event.target as HTMLInputElement;
    const currentValues = this.reactiveForm.get('sistemaBloquear').value || [];
  
    if (checkbox.checked) {
      this.reactiveForm.get('sistemaBloquear').setValue([...currentValues, value]);
    } else {
      this.reactiveForm
        .get('sistemaBloquear')
        .setValue(currentValues.filter((v: string) => v !== value));
    }
  }
}
